/* Build Stuff 2026 · newsletter pop-up */
(function () {
  'use strict';
  var dlg = document.querySelector('[data-bs-popup]');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  var KEY = 'bs-popup-2026';
  var days = parseInt(dlg.getAttribute('data-days'), 10) || 30;
  var delay = (parseInt(dlg.getAttribute('data-delay'), 10) || 0) * 1000;
  var done = dlg.querySelector('[data-bs-popup-done]');
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function set(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function open() { if (!dlg.open) { try { dlg.showModal(); } catch (e) {} } }
  function close() { if (dlg.open) dlg.close(); }
  var params = new URLSearchParams(location.search);
  var posted = !!done || params.get('customer_posted') === 'true';
  if (done) {
    set({ t: Date.now(), subscribed: true });
    open();
    var copy = dlg.querySelector('[data-bs-popup-copy]');
    var code = dlg.querySelector('[data-bs-popup-code]');
    if (copy && code) copy.addEventListener('click', function () {
      var t = code.textContent.trim();
      var ok = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1800); };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(t).then(ok, ok); else ok();
    });
  } else if (!posted) {
    var st = get();
    var fresh = st && (Date.now() - st.t) < days * 864e5;
    if (!(st && st.subscribed) && !fresh) {
      var timer = setTimeout(open, delay);
      document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 10) { clearTimeout(timer); open(); } }, { once: true });
    }
  }
  dlg.querySelectorAll('[data-bs-popup-close]').forEach(function (b) { b.addEventListener('click', close); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
  dlg.addEventListener('close', function () { var st = get(); if (!(st && st.subscribed)) set({ t: Date.now() }); });
  var form = dlg.querySelector('form');
  if (form) form.addEventListener('submit', function () { set({ t: Date.now(), pending: true }); });
})();
